import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import type { MultiValue } from 'react-select';
import UserProfileToggle from './user_profile_toggle';

export interface SubSpecialtyOption {
  label: string;
  value: number;
}

export interface UserSubSpecialty {
  id: number;
  subSpecialtyId: number;
}

export interface SubSpecialtiesProps {
  allSubSpecialties: SubSpecialtyOption[];
  pcUser?: boolean;
  showSubSpecialtiesOnBrokerPlugin: boolean;
  userSubSpecialties: UserSubSpecialty[];
}

export default function SubSpecialties({
  allSubSpecialties,
  pcUser = false,
  showSubSpecialtiesOnBrokerPlugin,
  userSubSpecialties
}: SubSpecialtiesProps) {
  const [subSpecialtiesOnBrokerPlugin, setSubSpecialtiesOnBrokerPlugin] =
    useState<boolean>(showSubSpecialtiesOnBrokerPlugin);

  const [selectedSubSpecialties, setSelectedSubSpecialties] = useState<number[]>(
    userSubSpecialties.map(u => u.subSpecialtyId)
  );

  function changeSelectedSubSpecialties(selectedOptions: MultiValue<SubSpecialtyOption>) {
    // react-select can return null, so handle that
    const options = (selectedOptions || []);
    setSelectedSubSpecialties(options.map(option => option.value));
  }

  const pcUserPrefix = pcUser ? 'parent_company_' : '';
  const subSpecialtiesBaseName = `${pcUserPrefix}user[${pcUserPrefix}user_sub_specialties_attributes]`;
  const persistedSubSpecialtyIds = userSubSpecialties.map(c => c.subSpecialtyId);
  const newSubSpecialtyIds = selectedSubSpecialties.filter(c => !persistedSubSpecialtyIds.includes(c));

  return (
    <React.Fragment>
      <h2 className="top-buffer-lg">Sub-Specialties</h2>
      <Row className="form-group">
        <Col md={6}>
          <Select
            classNamePrefix="react-select-buildout"
            isMulti
            options={allSubSpecialties}
            value={allSubSpecialties.filter(c => selectedSubSpecialties.includes(c.value))}
            onChange={changeSelectedSubSpecialties}
          />
        </Col>
      </Row>

      {userSubSpecialties.map((userSubSpecialty, index) => (
        <React.Fragment key={userSubSpecialty.id}>
          <input name={`${subSpecialtiesBaseName}[${index}][id]`} type="hidden" value={userSubSpecialty.id}/>
          <input
            name={`${subSpecialtiesBaseName}[${index}][sub_specialty_id]`}
            type="hidden"
            value={userSubSpecialty.subSpecialtyId}
          />
          <input
            name={`${subSpecialtiesBaseName}[${index}][_destroy]`}
            type="hidden"
            value={selectedSubSpecialties.includes(userSubSpecialty.subSpecialtyId) ? 'false' : 'true'}
          />
        </React.Fragment>
      ))}

      {newSubSpecialtyIds.map((subSpecialtyId, i) => {
        const index = i + userSubSpecialties.length;
        return (
          <input
            key={subSpecialtyId}
            name={`${subSpecialtiesBaseName}[${index}][sub_specialty_id]`}
            type="hidden"
            value={subSpecialtyId}
          />
        );
      })}

      {!pcUser &&
        <UserProfileToggle
          checked={subSpecialtiesOnBrokerPlugin}
          label="Show on Broker Plugin"
          name="user[show_sub_specialties_on_broker_plugin]"
          onChange={() => setSubSpecialtiesOnBrokerPlugin(!subSpecialtiesOnBrokerPlugin)}
        />
      }
    </React.Fragment>
  );
}
